import styles from "./MetaPluginItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import Button from "shared/Button";
import Link from "shared/Link";

/**
 *
 * Displays information about a group in a group list.
 */

export function MetaPluginItem({
  pluginInfo,
  onClick,
  onAddGroupClick,
  onBaseGroupClick,
}) {
  //To capitalized the first letter only
  function titleCase(pluginInfo) {
    const titleCase = pluginInfo
      .toLowerCase()
      .split(" ")
      .map((info) => {
        return info.charAt(0).toUpperCase() + info.slice(1);
      })
      .join(" ");

    return titleCase;
  }

  return (
    <div className={classNames(styles.container)}>
      <div className={styles.item}>
        <Link to={`/membership/lookup/ibo/${pluginInfo.plugeeIBONumber} `}>
          {pluginInfo.plugeeIBONumber}
        </Link>
      </div>
      <div
        className={classNames(styles.item, styles.baseGroupText)}
        // onClick={() => {
        //   onBaseGroupClick();
        // }}
      >
        {pluginInfo.plugeeOrganizationName} {pluginInfo.plugeeBusinessType}
      </div>
      <div className={classNames(styles.item, styles.targetIboText)}>
        <Link to={`/membership/lookup/ibo/${pluginInfo.targetIBONumber} `}>
          {pluginInfo.targetIBONumber}
        </Link>
      </div>
      <div
        className={classNames(styles.item, styles.addGroupText)}
        // onClick={() => {
        //   onAddGroupClick();
        // }}
      >
        {pluginInfo.targetOrganizationName} &gt;
        <span className={styles.groupName}>
          {titleCase(pluginInfo.targetGroupName)}
        </span>
      </div>
      <div className={styles.item}>
        <Button
          size="small"
          className={styles.detailsBtn}
          onClick={() => {
            onClick();
          }}
        >
          Details
        </Button>
      </div>
    </div>
  );
}

MetaPluginItem.propTypes = {
  /**
   * Object with the plugin info.
   */
  pluginInfo: PropTypes.shape({
    id: PropTypes.string,
    baseGroup: PropTypes.string,
    addGroup: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
  }),
  /**
   * Function called when details is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Function called when add group is clicked.
   */
  onAddGroupClick: PropTypes.func,
  /**
   * Function called when base group is clicked.
   */
  onBaseGroupClick: PropTypes.func,
};
